import TabPane from './TabPane'

export default TabPane
